module.exports = __webpack_public_path__ + "static/media/crowdfunding-icon.4ca2e51d.svg";